/**
 * Страница пользователя: комментарии проекта (user/projectcomments).
 *
 * Маркер инициализации — наличие #adm_file_attach и #send-button
 * (ограничивает страницей комментариев пользователя, не пересекается с manager/projectscomments).
 *
 * Конфиг — window.projectCommentsConfig (csrfToken, projectId, commentId, routes, i18n).
 *
 * Функционал:
 *   - выбор/отображение прикреплённых файлов;
 *   - удаление файла из существующего комментария;
 *   - модалка подтверждения удаления комментария;
 *   - автофокус и валидация формы (SEND активна только при тексте или файле);
 *   - real-time polling комментариев (через window.CommentsPolling).
 */

function init() {
    // Уникальный маркер именно user/projectcomments.blade.php
    if (!document.getElementById('comment-form')) return;

    const config = window.projectCommentsConfig;
    if (!config) {
        console.error('[project-comments] window.projectCommentsConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[project-comments] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};

    $(() => {
        // Открытие диалога выбора файлов
        $('#adm_file_attach').on('click', function (e) {
            e.preventDefault();
            $('#file-upload-comment').click();
        });

        // Отображение выбранных файлов
        $('#file-upload-comment').on('change', function () {
            const files = this.files;
            const uploadedBlock = $('#adm_file_uploaded');
            if (files.length === 0) return;

            uploadedBlock.addClass('active');
            uploadedBlock.find('.new-file').remove();

            for (let i = 0; i < files.length; i++) {
                const fileDiv = $('<div>')
                    .addClass('adm_post_sender_uploaded_file noselect new-file')
                    .html(config.i18n.attachment + ': <span></span>');
                fileDiv.find('span').text(files[i].name);
                uploadedBlock.append(fileDiv);
            }
        });

        // Удаление файла из существующего комментария
        $(document).on('click', '.remove-file-url', function (e) {
            e.preventDefault();
            const fileId = $(this).data('id');
            const commentId = config.commentId;
            if (!commentId || !fileId) {
                showToast('error', config.i18n.error);
                return;
            }
            window.location.href = config.routes.removeFileBase + '/' + commentId + '/removefile/' + fileId;
        });

        // Модалка подтверждения удаления комментария
        let deleteCommentId = null;
        let deleteProjectId = null;

        $(document).on('click', '.delete-comment_btn', function (e) {
            e.preventDefault();
            deleteCommentId = $(this).data('id');
            deleteProjectId = $(this).data('project');
            $('#confirm-delete-modal').fadeIn(200);
        });

        $('#confirm-delete-btn').on('click', async function () {
            if (!deleteCommentId || !deleteProjectId) return;
            const url = config.routes.removeCommentBase + '/' + deleteProjectId + '/comments/' + deleteCommentId + '/removeComment';
            try {
                const resp = await fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': config.csrfToken,
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                    },
                });
                if (resp.ok || resp.redirected) {
                    window.location.reload();
                } else {
                    showToast('error', config.i18n.error);
                }
            } catch (e) {
                showToast('error', config.i18n.error);
            }
        });

        $('#modal-close, #modal-cancel, .custom-modal-backdrop').on('click', function () {
            $('#confirm-delete-modal').fadeOut(200);
            deleteCommentId = null;
            deleteProjectId = null;
        });

        // Автоматический ресайз textarea + автофокус при редактировании
        const textarea = document.querySelector('textarea[name="message"]');
        if (textarea) {
            if (textarea.value) {
                textarea.parentNode.dataset.value = textarea.value;
            }

            if (config.commentId || config.prefill) {
                textarea.focus();
                textarea.setSelectionRange(textarea.value.length, textarea.value.length);
            }

            const sendButton = document.getElementById('send-button');
            const fileInput = document.getElementById('file-upload-comment');

            function checkFormValidity() {
                const hasText = textarea.value.trim().length > 0;
                const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
                if (sendButton) sendButton.disabled = !(hasText || hasFile);
            }

            if (sendButton) {
                checkFormValidity();
                textarea.addEventListener('input', checkFormValidity);
                if (fileInput) fileInput.addEventListener('change', checkFormValidity);
            }
        }

        // Показываем блок прикреплённых файлов, если они есть
        if ($('#adm_file_uploaded').children().length > 0) {
            $('#adm_file_uploaded').addClass('active');
        }

        // Реал-тайм опрос новых комментариев
        if (typeof window.CommentsPolling !== 'undefined') {
            window.CommentsPolling.init(config.projectId);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
